module.exports = __webpack_public_path__ + "img/medal-solid.5961832e.svg";